import { InputNumber, Button, Space, Typography } from "antd";
import { useQuizContext } from "Pages/MySchedule/MyScheduledBeta/quiz/context/QuizContext";
import { useEffect, useState } from "react";
import {
  BASE_URL,
  QUESTION_AUTO_PICK,
} from "utilFunctions/Constants/urlConstants";
interface GenerateQuestionForm {
  onAddHandler?: () => void;
  selectedRows?: any[];
}

const GenerateQuestionForm = ({
  onAddHandler,
  selectedRows = [],
}: GenerateQuestionForm) => {
  const [limit, setLimit] = useState(0);
  const { fetchQuestions, stepperForm, refresh } = useQuizContext();
  const { step1, step2 } = stepperForm || {};
  const { questionType, lod1, streamId } = step1;
  const { chapterIds = [], nodeIds = [] } = step2 || {};
  useEffect(() => {
    if (refresh) {
      setLimit(0);
    }
  }, [refresh]);
  return (
    <Space
      direction="horizontal"
      style={{
        width: "100%",
        justifyContent: "space-between",
        padding: "12px",
        borderRadius: "12px",
        border: "0.5px solid #f2e8e8",
      }}
      size={12}
    >
      <Space>
        <Typography.Text>Questions</Typography.Text>

        <InputNumber
          min={0}
          max={245}
          value={limit}
          style={{ width: "100%" }}
          onChange={(value: any) => {
            setLimit(value);
          }}
        />
      </Space>
      <Space>
        <Button
          type="primary"
          block
          onClick={() => {
            let url =
              BASE_URL +
              QUESTION_AUTO_PICK +
              `?limit=${limit}&offset=0&questionType=${questionType}&lod1=${lod1}&doRandomization=true&streamId=${streamId}&questionStatus=Published`;
            if (chapterIds?.length) {
              url = url + "&chapterIds=" + chapterIds.join(",");
            }
            if (nodeIds?.length) {
              url = url + "&nodeIds=" + nodeIds.join(",");
            }
            fetchQuestions(url);
          }}
          disabled={limit > 0 ? false : true}
        >
          Generate
        </Button>
        <Button
          disabled={!selectedRows.length}
          type={!selectedRows.length ? "default" : "primary"}
          onClick={onAddHandler}
        >
          Add
        </Button>
      </Space>
    </Space>
  );
};

export default GenerateQuestionForm;
